<template>
  <v-menu
    v-model="opened"
    fixed
    content-class="zoox-component zoox-context-menu mt-2"
    :position-x="position.x"
    :position-y="position.y"
  >
    <v-list dense class="zoox-component zoox-context-menu">
      <v-list-item
        v-for="(option, index) in options"
        ref="menu-option"
        :key="index"
        color="primary"
        @click="onClickOption(option)"
      >
        <v-list-item-title>{{ option.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
/**
 * @displayName Context Menu
 */
export default {
  name: 'ZContextMenu',
  props: {
    /**
     * Array de opções do menu de contexto
     *
     * @typedef {text: string, action: string}
     */
    options: {
      type: Array,
    },
  },
  data() {
    return {
      contextData: null,
      opened: false,
      position: {
        x: 0,
        y: 0,
      },
    }
  },
  methods: {
    /**
     * Método de abertura do context menu.
     *
     * @public
     */
    open(event, data) {
      if (!event) {
        throw new Error(
          'Obrigatório passar o evento nativo para o open do z-context-menu'
        )
      }
      event.preventDefault()
      this.opened = true
      this.position.x = event.x
      this.position.y = event.y
      this.contextData = data
    },

    /**
     * Método para fechar o context menu por fora programaticamente
     *
     * @public
     */
    close() {
      this.opened = false
    },

    /**
     * Método para verificar se está ou não aberto
     *
     * @public
     */
    isOpened() {
      return this.opened
    },

    onClickOption(option) {
      /**
       * Disparado quando uma opção é clicada
       *
       * @property {Object} option - Objeto refetente á opção clicada
       * @property {any} data - Payload para identificar em qual elemento o context menu foi acionado
       */
      this.$emit('click', {option, data: this.contextData})
      this.opened = false
      this.contextData = null
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-context-menu {
  box-shadow: var(--zoox-card-shadow) !important;
  border-radius: var(--component-card-radius);
}
</style>
